import { Injectable } from '@angular/core';
import { StorageService } from 'app/global/storage.service';
import { RouterService } from 'app/global/router.service';
import { BaseRedirectGuard } from './base-redirect.guard';

@Injectable({ providedIn: 'root' })
export class CrmAuthGuard extends BaseRedirectGuard {
  constructor(
    private _storageService: StorageService,
    _routerService: RouterService
  ) {
    super(_routerService);
  }

  async checkCondition(): Promise<boolean> {
    this._routerService.setCrmParams();
    const isCrmUser = this._storageService.getItem('is_crm_user');
    return isCrmUser && Number(isCrmUser) === 1;
  }

  getRedirectUrl(): string {
    return '/integrations/select-template';
  }
}
